<template>
  <div id="addEdit">
    <el-dialog :title="formData.id?'编辑组件':'添加组件'" :visible.sync="visible" width="700px">
      <el-form :model="formData" size="small" label-width="80px" ref="formRef" :rules="rules">

        <!-- <el-form-item label="key" prop="key">
          <el-input v-model="formData.key" :disabled="formData.id==null?false:true"  placeholder="请输入key"></el-input>
        </el-form-item> -->

        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="formData.type">
            <el-radio v-for="item in typeList" :label="item.value" :key="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item label="图片" prop="file.file_id" :rules="[{ required: true, message: '请上传图片', trigger: 'change' }]" v-if="formData.type!=1">
          <el-button type="primary" @click="isupload=true">选择图片</el-button>
          <div v-if="formData.file.file_id" class="img">
            <img :src="formData.file.file_path" width="100" height="100" />
          </div>
        </el-form-item>



        <el-form-item label="内容" prop="content">

          <Uediter v-if="ueShow" :config="config"  :text="formData.content"  v-model="formData.content" @contentChange="contentChangeFunc"></Uediter>


          <!-- <el-input v-model="formData.content" placeholder="请输入内容"></el-input> -->
        </el-form-item>

      </el-form>
      <div slot="footer"  class="dialog-footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>


      <Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


    </el-dialog>

  </div>
  </template>

  <script>
  import Upload from '@/components/file/Upload';
  import Uediter from '@/components/UE.vue';
  import SettingApi from '@/api/setting.js';
  export default {
    components:{Uediter,Upload},
    data(){
      return{
        ueShow:false,
        visible:false,
        isupload:false,
        detail:{},
        config: {
          initialFrameWidth: 580,
          initialFrameHeight: 500,
        },
        formData:{
          key:'',
          title:'',
          type:'',
          file:{},
          content:'',
          sort:1,
        },
        rules:{
          key: [{ required: true, message: '请输入key', trigger: 'blur' }],
          type: [{ required: true, message: '请选择类型', trigger: 'change' }],
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
          content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        },
        loading:false
      }
    },
    props:{
      typeList:Array
    },
    methods:{

      // 开启
      show(e){
        this.ueShow=false
        this.visible=true
        delete this.formData.id
        if(e&&e!=''){
          for(let i in this.formData){
            this.formData[i]=e[i]
          }
          this.formData.id=e.id
          this.formData.file={
            file_id:e.file_id,
            file_path:e.file_path,
          }
        }else{
          for(let i in this.formData){
            this.formData[i]=''
          }
          this.formData.file={
            file_id:'',
            file_path:'',
          }
        }
        console.log(this.formData);

        this.$nextTick(()=>{
          this.ueShow=true
        })
        // this.detail=e
        // this.formData.apply_id=e.apply_id
      },

      // 提交
      submitForm(){
        this.$refs.formRef.validate(valid => {
          if (valid) {
            this.loading=true
            let API
            if(this.formData.id){
              API=SettingApi.postComponentEdit
            }else{
              API=SettingApi.componentAdd
            }
            API(this.formData).then(res=>{
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.visible=false
              this.$emit('refresh')
            }).finally(()=>{
              this.loading=false
            })

          }
        })
      },

      contentChangeFunc(e){
        this.formData.content=e
      },


      // 图片上传
      uploadChange(e){
        if(e&&e!=''){
          this.formData.file=e[0];
        }
        this.isupload=false
      },

    }

  }
  </script>

  <style lang="scss" scoped>
  ::v-deep .el-image{width: 50px;height: 50px;margin: 4px;}
  </style>



// WEBPACK FOOTER //
// src/views/setting/component/addEdit.vue